function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import CommonStrata from "../../Models/Definition/CommonStrata";
import { StyledIcon } from "../../Styled/Icon";
import Text from "../../Styled/Text";
import { parseCustomMarkdownToReactWithOptions } from "../Custom/parseCustomMarkdownToReact";
import Button from "../../Styled/Button";
import AnimatedSpinnerIcon from "../../Styled/AnimatedSpinnerIcon";
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectableDimensionButton = _ref => {
  var _dim$value;
  let {
    dim
  } = _ref;
  const iconGlyph = dim.icon;
  const iconProps = {
    light: true,
    styledWidth: "16px",
    styledHeight: "16px"
  };
  return /*#__PURE__*/_jsx(Button, {
    onClick: () => runInAction(() => dim.setDimensionValue(CommonStrata.user, true)),
    activeStyles: true,
    shortMinHeight: true,
    renderIcon: () => iconGlyph === "spinner" ? /*#__PURE__*/_jsx(AnimatedSpinnerIcon, _objectSpread({}, iconProps)) : iconGlyph ? /*#__PURE__*/_jsx(StyledIcon, _objectSpread({
      glyph: iconGlyph
    }, iconProps)) : undefined,
    style: {
      backgroundColor: "transparent"
    },
    children: /*#__PURE__*/_jsx("div", {
      style: {
        display: "flex"
      },
      children: /*#__PURE__*/_jsx(Text, {
        textLight: true,
        children: parseCustomMarkdownToReactWithOptions((_dim$value = dim.value) !== null && _dim$value !== void 0 ? _dim$value : "", {
          inline: true
        })
      })
    })
  });
};